export default "__VITE_ASSET__OxE4p$v0__"